import React, {useEffect} from 'react'
import {Col, Row} from 'react-bootstrap'
import ByondGrid2 from "../../../../customGrid/CustomGrid";
import {AssetAlertGridTemplate} from './AssetAlertGridTemplate';

export const mapToFriendlyName = (data) => {
  if (!data) {
    return 'Sem dados';
  }
  return data.map(x => <li key={x.id}>{x.friendlyName}</li>);
}

function PermanenceDetailType({data, setCurrentDetailType}) {

  const templateGrid = new AssetAlertGridTemplate(data);

  useEffect(() => {
    if (!data) {
      return
    }
    setCurrentDetailType({
      metadata: templateGrid,
      endpoint: templateGrid.endpoint()
    })
  }, [data])

  return (
    <Row className="mt-3">
      <Col md={3}>
        <h4 style={{fontWeight: 'bold'}}>Tipo(s) de Produto(s):</h4>
        <ul> {mapToFriendlyName(data.alertConfiguration.productTypes)}</ul>
      </Col>
      <Col md={3}>
        <h4 style={{fontWeight: 'bold'}}>Local/Locais:</h4>
        <ul> {mapToFriendlyName(data.alertConfiguration.bizLocations)}</ul>
      </Col>
      <Col md={3}>
        <h4 style={{fontWeight: 'bold'}}>Etapa(s):</h4>
        <ul> {mapToFriendlyName(data.alertConfiguration.bizSteps)}</ul>
      </Col>
      <Col md={3}>
        <h4 style={{fontWeight: 'bold'}}>Disposição/Disposições:</h4>
        <ul> {mapToFriendlyName(data.alertConfiguration.dispositions)}</ul>
      </Col>
      <Col md={3}>
        <h4 style={{fontWeight: 'bold'}}>Intervalo em horas:</h4>
        <ul> {data.alertConfiguration.durationInHours} hora(s)</ul>
      </Col>
      <Col md={12} className="mt-3 mb-4">
        <ByondGrid2 endpoint={templateGrid.endpoint()} metadata={templateGrid} removeBox/>
      </Col>
    </Row>
  )
}

export {PermanenceDetailType}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/PermanenceAlert/PermanenceDetailType.js